export default __webpack_public_path__ + "static/media/celebrate.52026365afe0fd583f01f30a47a6fb55.svg";